export default __webpack_public_path__ + "static/media/contact-owner.edb10808.png";